// extracted by mini-css-extract-plugin
module.exports = {"TheComp":"H_TheComp__1LciF"};